import React, { useState } from "react";
import styled from "styled-components";
import { Add, Remove } from "@material-ui/icons";
import { useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { addProduct } from "../redux/cartRedux";
import { selectProducts } from "../redux/productRedux";

const Container = styled.div`
  padding: 50px;
  display: flex;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding: 30px;
  }
`;
const Image = styled.img`
  flex: 1;
  width: 100%;
  height: 90vh;
  object-fit: cover;
  border-radius: 10px;
`;
const Info = styled.div`
  flex: 1;
  padding: 0 50px;

  @media only screen and (max-width: 768px) {
    padding: 10px;

    h2 {
      font-size: 30px;
      align-self: flex-start;
    }
  }

  h2 {
    font-weight: 200;
    font-size: 40px;

    @media only screen and (max-width: 768px) {
      font-size: 30px;
    }
  }

  .description {
    margin: 20px 0;
    font-weight: 200;
    font-size: 20px;
  }

  span {
    font-weight: 100;
    font-size: 40px;
  }
`;
const Filters = styled.div`
  margin: 30px 0px;
  display: flex;
  flex-direction: column;

  h3 {
    font-size: 20px;
    font-weight: 200;
  }

  .filter {
    margin: 10px 0;

    &.color {
      font-size: 24px;
      padding: 5px;
      flex-direction: column;
      align-items: flex-start;

      span {
        font-size: 24px;
      }

      .color-wrapper {
        display: flex;
      }
    }

    &.size {
      span {
        font-size: 24px;
      }

      .color-wrapper {
        display: flex;

        .size-item {
          text-align: center;
          border: solid 1px black;
          width: 40px;
          border-radius: 5px;
          margin-right: 5px;

          span {
            font-size: 24px;
            padding: 5px;
          }
        }
      }
    }
  }
`;
const ColorItem = styled.div`
  height: 30px;
  width: 30px;
  background-color: ${props => props.color};
  border-radius: 5px;
  margin-right: 15px;

  &.active {
    border: solid 1px black;
  }
`;
const Amount = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;

  .icon {
    font-size: 30px;
    cursor: pointer;
  }

  span {
    width: 30px;
    height: 30px;
    font-size: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px 5px;
  }

  button {
    margin-left: 20px;
    padding: 15px;
    border: 2px solid black;
    border-radius: 10px;
    background-color: black;
    color: white;
    cursor: pointer;
    font-weight: 500;

    &:hover {
      background-color: white;
      color: black;
    }
  }
`;

export default function Product() {
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const dispatch = useDispatch();

  // read state to get all products, find clicked product by accessing URL
  const products = useSelector(selectProducts);
  const currentProduct = products?.find(item => item._id === id);

  // setting cart state values
  const [quantity, setQuantity] = useState(1);
  const [color, setColor] = useState("");
  const [size, setSize] = useState("");

  const handleQuantity = type => {
    if (type === "inc") {
      setQuantity(quantity + 1);
    } else {
      quantity > 1 && setQuantity(quantity - 1);
    }
  };
  const handleSubmit = () => {
    // checks not to add item without size or color to basket
    if (color === "" || size === "") return;

    // creating cart Id value
    const rand = Math.floor(Math.random() * 100000000);

    dispatch(
      addProduct({ ...currentProduct, quantity, color, size, cartId: rand })
    );
  };

  return (
    <>
      <Container>
        <Image src={currentProduct.img} alt="" />
        <Info>
          <h2>{currentProduct.title}</h2>
          <span>£140</span>
          <Filters>
            <div className="filter color">
              <h3>
                Color: <span>{color}</span>
              </h3>
              <div className="color-wrapper">
                {currentProduct.color?.map(color => (
                  <ColorItem
                    key={color}
                    // set product color
                    color={color}
                    onClick={() => setColor(color)}
                  ></ColorItem>
                ))}
              </div>
            </div>
            <div className="filter size">
              <h3>
                Size: <span>{size}</span>
              </h3>
              <div className="color-wrapper">
                {currentProduct.size?.map(size => (
                  <div className="size-item" key={size}>
                    <span
                      value={size}
                      // set product size
                      onClick={e => {
                        setSize(e.target.getAttribute("value"));
                      }}
                    >
                      {size}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </Filters>
          <Amount>
            <Remove
              className="icon"
              // increment product quantity
              onClick={() => handleQuantity("dec")}
            />
            <span>{quantity}</span>
            <Add
              className="icon"
              // decrement product quantity
              onClick={() => handleQuantity("inc")}
            />
            <button onClick={handleSubmit}>ADD TO CART</button>
          </Amount>
          <p className="description">{currentProduct.description}</p>
        </Info>
      </Container>
      <Footer />
    </>
  );
}
